/**
 * 封装 axios
 */
import axios from 'axios';
import qs from 'qs';
import router from '@/router';

const ajax = axios.create({
  baseURL: process.env.API_HOST,
  method: 'post',
  timeout: 300000,
  headers: {
    'Token': localStorage.getItem('token')||''
  },
  // 跨域请求，携带凭证。
  withCredentials: true,
  // 服务器相应数据类型
  responseType: 'json',
  // 发送前修改数据

});

// 请求拦截
ajax.interceptors.request.use(
  config => {
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);
// 返回拦截
ajax.interceptors.response.use(response => {
  if(response.data.code==210){
    localStorage.clear();
    router.replace({
      path:'/'
    })
    alert('账号过期请重新登录！')
  }

  return response.data;
}, error => {
  return Promise.reject(error);
});

ajax.install = (Vue) => {
  Vue.prototype.$ajax = ajax;
};

export default ajax;



// WEBPACK FOOTER //
// ./src/assets/js/ajax.js